// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2IxGk","text":"style_text__3Nvhw"};